import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function getCookie(name: string) {
  const regex = new RegExp(`(^| )${name}=([^;]+)`);
  const match = document.cookie.match(regex);
  if (match) {
    return match[2];
  }
}

export function deleteCookie(name: string, domain: string) {
  document.cookie =
    name +
    `=; Domain=${domain}; Path=/; Secure; SameSite=None Expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
}

type Item = {
  id: string | number;
};

export function arrayToObject(inputArray: Item[]) {
  return inputArray.reduce((agg, item) => ({ ...agg, [item?.id]: item }), {});
}
